<script setup lang="ts">
import { ref } from 'vue'
import QuantumAquarium from '../components/QuantumAquarium.vue'

const showGuide = ref(false)

const toggleGuide = () => {
  showGuide.value = !showGuide.value
}
</script>

<template>
  <main>
    <QuantumAquarium />

    <div class="quantum-guide">
      <button class="guide-toggle" @click="toggleGuide">?</button>
      <div class="guide-content" v-show="showGuide">
        <h3>量子饲料实验室 - 操作指南</h3>
        <ul>
          <li>点击水族箱中的任意位置投放量子饲料</li>
          <li>不同颜色的饲料有不同属性（标准、反重力、超导体、黑洞）</li>
          <li>当量子鱼吃下饲料后会发生变异，增加器官或改变外形</li>
          <li>变异等级高的鱼有机会繁殖产生新鱼</li>
          <li>混沌量表满格时会触发全屏量子震动</li>
          <li>尝试解锁隐藏成就以体验特殊效果</li>
        </ul>
        <div class="credit">量子实验室 v1.0</div>
      </div>
    </div>
  </main>
</template>

<style scoped>
main {
  width: 100vw;
  margin: 0;
  padding: 0;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  overflow-x: hidden;
  box-sizing: border-box;
}

.quantum-guide {
  position: fixed;
  bottom: 20px;
  left: 20px;
  z-index: 1000;
}

.guide-toggle {
  width: 36px;
  height: 36px;
  border-radius: 50%;
  background: rgba(0, 0, 0, 0.5);
  color: white;
  font-size: 18px;
  font-weight: bold;
  border: 2px solid rgba(255, 255, 255, 0.3);
  cursor: pointer;
  transition: all 0.3s ease;
  display: flex;
  align-items: center;
  justify-content: center;
}

.guide-toggle:hover {
  background: rgba(0, 0, 0, 0.7);
  transform: scale(1.1);
}

.guide-content {
  position: absolute;
  bottom: 50px;
  left: 0;
  width: 300px;
  background: rgba(0, 0, 0, 0.8);
  color: white;
  border-radius: 10px;
  padding: 15px;
  font-size: 14px;
  backdrop-filter: blur(5px);
  border: 1px solid rgba(255, 255, 255, 0.1);
  animation: fadeIn 0.3s ease;
}

.guide-content h3 {
  margin-top: 0;
  color: var(--accent-color, #ff4fff);
  font-size: 16px;
}

.guide-content ul {
  margin: 10px 0;
  padding-left: 20px;
}

.guide-content li {
  margin-bottom: 8px;
  line-height: 1.4;
}

.credit {
  font-size: 12px;
  text-align: right;
  opacity: 0.6;
  margin-top: 10px;
}

@keyframes fadeIn {
  from {
    opacity: 0;
    transform: translateY(10px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}
</style>
